import React from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormFields, FormTextField } from "sprint-common-web";

import { useCreateOriginatorForm } from "./useCreateOriginatorForm";

export interface CreateOriginatorFormProps {
    onCancel(): void;
    onSubmit(): void;
}

export interface CreateOriginatorFormInputs {
    name: string;
}

export const CreateOriginatorForm: React.VFC<CreateOriginatorFormProps> = ({
    onSubmit,
    onCancel
}: CreateOriginatorFormProps) => {
    const { errors, control, formState, handleSubmit } = useForm<CreateOriginatorFormInputs>({
        defaultValues: {
            name: ""
        },
        criteriaMode: "all"
    });

    const { create, validateName } = useCreateOriginatorForm();

    const handleCancelButtonClick = () => {
        onCancel();
    };

    const handleCreateOriginator = async (inputs: CreateOriginatorFormInputs) => {
        await create(inputs);
        onSubmit();
    };

    return (
        <Form onSubmit={handleSubmit(handleCreateOriginator)}>
            <FormFields>
                <FormTextField
                    label="Name"
                    control={control}
                    name="name"
                    errors={errors}
                    rules={{ required: "Enter name", validate: validateName }}
                />
            </FormFields>
            <FormActions
                isLoading={formState.isSubmitting || formState.isValidating}
                onCancel={handleCancelButtonClick}
            />
        </Form>
    );
};
